import React from "react";
import "@/App.css";
import { GrainOverlay } from "./components/GrainOverlay";
import { ScrollProgress } from "./components/ScrollProgress";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { About } from "./components/About";
import { FeaturedCategories } from "./components/FeaturedCategories";
import { FullMenu } from "./components/FullMenu";
import { SignaturePicks } from "./components/SignaturePicks";
import { Gallery } from "./components/Gallery";
import { LocationContact } from "./components/LocationContact";
import { Footer } from "./components/Footer";

function App() {
  return (
    <div className="App relative bg-cream text-soft" data-testid="oroma-app">
      <GrainOverlay />
      <ScrollProgress />
      <Navbar />
      <main>
        <Hero />
        <About />
        <FeaturedCategories />
        <FullMenu />
        <SignaturePicks />
        <Gallery />
        <LocationContact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
